import Story from "../../components/Story/Story";
import { useLoginModalContext } from "../../app/context/LoginModal";
import { isLoggedin } from "../../app/helpers/helper";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

function StoryView() {
  const { setShowLoginModal } = useLoginModalContext();
  const [isViewerOpen, setIsViewerOpen] = useState(true);
  const [canViewStory, setCanViewStory] = useState<boolean | null>(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const pageType = searchParams.get("type");

  const loginModalHandler = () => {
    setShowLoginModal(true);
  };

  const handleStoryClose = () => {
    setIsViewerOpen(false);
    navigate(-1);
    // if (pageType === "feed") {
    //   navigate("/vertical-player");
    // } else if (pageType === "discover") {
    //   navigate("/discover");
    // } else if (pageType === "profile") {
    //   navigate("/my-profile");
    // } else {
    //   navigate("/vertical-player");
    // }
  };

  useEffect(() => {
    let isActive = true;

    const checkLogin = async () => {
      const loggedIn = await isLoggedin();
      if (!isActive) return;
      if (!loggedIn) {
        setShowLoginModal(true);
        setCanViewStory(false);
        return;
      }
      setCanViewStory(true);
    };

    checkLogin();

    return () => {
      isActive = false;
    };
  }, [setShowLoginModal]);

  return (
    <div className="full-sec"><div className="right-sec">
        {/* <button onClick={() => setIsViewerOpen(true)}>Open Stories</button> */}
        {isViewerOpen && canViewStory && (
          <Story
            onClose={() => {
              handleStoryClose();
            }}
          />
        )}
      </div>
    </div>
  );
}

export default StoryView;
